goog.provide("shadow.js.shim.module$src$svg$artwork$broken_link_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$broken_link_svg");
shadow.js.shim.module$src$svg$artwork$broken_link_svg = shadow.js.nativeProvides["src/svg/artwork/broken-link.svg"] = shadow$bridge("src/svg/artwork/broken-link.svg");
module$shadow_js_shim_module$src$svg$artwork$broken_link_svg.default = shadow.js.shim.module$src$svg$artwork$broken_link_svg;
